import React, { useState, useEffect, useRef } from 'react';
import './SessionNotice.css';

// Keep in sync with the fade-out animation in SessionNotice.css
const FADE_OUT_MS = 300;

/**
 * Auto-dismissing notice shown when a session was (re-)started under a
 * bookmarked code. A progress bar counts the remaining time down; the notice
 * can also be closed manually before that.
 */
function SessionNotice({ duration = 8000, onDismiss, children }) {
  const [leaving, setLeaving] = useState(false);
  const timersRef = useRef([]);

  useEffect(() => {
    const clear = () => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current = [];
    };

    timersRef.current = [
      setTimeout(() => setLeaving(true), duration),
      setTimeout(onDismiss, duration + FADE_OUT_MS),
    ];

    return clear;
  }, [duration, onDismiss]);

  const handleClose = () => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [setTimeout(onDismiss, FADE_OUT_MS)];
    setLeaving(true);
  };

  return (
    <div className={`session-notice${leaving ? ' session-notice-leaving' : ''}`}>
      <span className="session-notice-icon">✨</span>
      <div className="session-notice-text">{children}</div>
      <button
        className="session-notice-close"
        onClick={handleClose}
        title="Hinweis ausblenden"
      >
        ✕
      </button>
      <span
        className="session-notice-progress"
        style={{ animationDuration: `${duration}ms` }}
      />
    </div>
  );
}

export default SessionNotice;
